import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Button } from "react-bootstrap";
import { Box } from "@mui/material";
import { AddCircle, Home, People } from "@mui/icons-material";
import IconBreadcrumbs from "../../../components/custom/IconBreadcrumbs";
import Banks from "../banks/Banks";
import Branches from "./Branches";
import AddUpdateBanks from "../banks/AddUpdateBanks";
import AddUpdateBranches from "./AddUpdateBranches";
import { useGetBankQuery } from "../../../redux/api/applicationPaymentProcessApiSlice";

const BankAndBranch = () => {
  const [activeTab, setActiveTab] = useState("bank");

  const [showBankModal, setShowBankModal] = useState(false);
  const [bankEditData, setBankEditData] = useState(null);

  const [showBranchModal, setShowBranchModal] = useState(false);
  const [branchEditData, setBranchEditData] = useState(null);

  const { data: fetchBank } = useGetBankQuery();

  const breadcrumbsData = [
    { icon: Home, title: "হোম", url: "/" },
    {
      icon: People,
      title: "ব্যাংক ও শাখাসমূহের তালিকাঃ",
      url: "/admin/branches",
      active: true,
    },
  ];

  return (
    <div>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        py={1}
        mb={1}
      >
        <IconBreadcrumbs breadcrumbs={breadcrumbsData} />
        <Box display={"flex"} gap={2}>
          <Button
            variant="outline-secondary"
            onClick={() => {
              setBankEditData(null);
              setShowBankModal(true);
            }}
          >
            <AddCircle />
            ব্যাংক যোগ করুন
          </Button>
          <Button
            variant="outline-secondary"
            onClick={() => {
              setBranchEditData(null);
              setShowBranchModal(true);
            }}
          >
            <AddCircle />
            শাখা যোগ করুন
          </Button>
        </Box>
      </Box>

      <div className="slideUp dashboard-layout p-3">
        <Tabs
          activeKey={activeTab}
          onSelect={(key) => setActiveTab(key)}
          id="bank-and-branch-tabs"
          className="mb-3"
        >
          <Tab eventKey="bank" title="ব্যাংক">
            <Banks
              showModal={showBankModal}
              setShowModal={setShowBankModal}
              editData={bankEditData}
              setEditData={setBankEditData}
            />
          </Tab>
          <Tab eventKey="branch" title="ব্যাংক শাখা">
            <Branches
              showModal={showBranchModal}
              setShowModal={setShowBranchModal}
              editData={branchEditData}
              setEditData={setBranchEditData}
            />
          </Tab>
        </Tabs>
      </div>

      <AddUpdateBanks
        data={bankEditData}
        show={showBankModal}
        onHide={() => {
          setShowBankModal(false);
          setBankEditData(null);
        }}
        onSuccess={() => setActiveTab("bank")}
      />
      <AddUpdateBranches
        data={branchEditData}
        show={showBranchModal}
        bank={fetchBank?.data || []}
        onHide={() => {
          setShowBranchModal(false);
          setBranchEditData(null);
        }}
        onSuccess={() => setActiveTab("branch")}
      />
    </div>
  );
};

export default BankAndBranch;
